import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import noImage from "../../Image/no-image.jpg";
import { BASE_URL } from "../../Utils/base_url";
import Spinner from "react-bootstrap/Spinner";
import Pagination from '@material-ui/lab/Pagination';
import { AfficheAvisDeposer } from '../../Api/ClientApi/ResaAvisApi';
import Slider from "react-slick";
import './css/avisClient.css';
import db from '../../db';

const Avis = () => {

    const [loadData, setLoadData] = useState(false);
    const [data, setData] = useState([]);
    const [totalAvis, setTotalAvis] = useState("");
    const [totalResa, setTotalResa] = useState([]);
    const [showPaginate, setShowPaginate] = useState(true);
    const [totalPage, setTotalPage] = useState();
    const [page, setPage] = useState(1);
    const [openDropDown, setOpenDropDown] = useState(false);
    const [test,setTest] = useState([]);

    let navigate = useNavigate();
    let location = useLocation();
    const client = useSelector((state) => state.client);
    useEffect(() => {
        const fetchAndSetData = async()=> {
        try {
          const donner = await db.monTableau.toArray();
          if (donner.length > 0) {
            setTest(donner);
            console.log("Donner dans dexi=>",donner);
          }
        } catch (error) {
          console.error('Erreur lors de la récupération des données depuis Dexie :', error);
        }
      };
      fetchAndSetData();
      }, []);

    useEffect(() => {
        AfficheAvisClient();
        if (totalResa.length < 4) {
            setShowPaginate(false);
        } else {
            setShowPaginate(true);
        }
    }, [totalResa.length]);

    const AfficheAvisClient = (value = null) => {
        let dataPage = value === null ? page : value;
        setLoadData(true);
        AfficheAvisDeposer(client.id, dataPage)
            .then(function (response) {
                console.log("data =>", response.data.donner);
                setData(response.data.donner);
                setTotalAvis(response.data.totalRows);
                setTotalPage(response.data.totalPage);
                setTotalResa(response.data.totalResa);
                console.log("dataTotal =>", response.data.totalResa);
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                setLoadData(false);
            });
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };


    const formatPlural = (value) => {
        if (value < 10) {
            return "0" + value;
        } else {
            return value;
        }
    };

    const formatDate = (date) => {
        const datePrise = new Date(date);
        return (
            formatPlural(datePrise.getDate()) +
            "/" +
            formatPlural(datePrise.getUTCMonth() + 1) +
            "/" +
            datePrise.getFullYear()
        );
    };

    const formatTime = (time) => {
        return formatPlural(new Date(time).getHours()) + "h " + formatPlural(new Date(time).getMinutes() + "min");
    };

    const formatDateLink = (date) => {
        const datePrise = new Date(date);
        return (
            datePrise.getFullYear() + "-" + formatPlural(datePrise.getUTCMonth() + 1) + "-" + formatPlural(datePrise.getDate())
        );
    }


    const viewAvis = (item, index) => {
        const restaurant = test?.find(
            (el) => el.id === parseInt(item.restaurant?.id)
        );
  

        if (item.avis.length !== 0) {
            return (
                <div className='card' key={index}>
                    <div className='row'>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-2'>
                            <div className='image_card'>
                                <img
                                    src={
                                        restaurant.photos.length === 0
                                            ? noImage
                                            : BASE_URL + restaurant.photos[0]?.urlPhoto
                                    }
                                    alt="logo restaurant"
                                />
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-2'>
                            <div className="apropos_restaurant">
                                <span>{restaurant.typeCuisines[0].libelle}</span>
                                <h3>{restaurant.nomRestaurant}</h3>
                                <span>{restaurant.adresse} </span>
                                <div className="date_personne">
                                    <span className='date'>Réservation du {formatDate(item.datePrise)}</span><br />
                                    <span className='personne'>Pour {item.nombrePersonne} pérsonnes</span>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                            <div className='apropos_avis'>
                                <h4><i className='fa fa-star'></i> Note: {item.notes[0]?.note}/20</h4>
                                <div className='d-flex justify-content-end'>
                                    <div className='avis_via_client'>
                                        <p>{item.avis[0]?.avis}</p>
                                    </div>
                                </div>
                                {item.avis[0]?.reponse !== null ?
                                    <div className='d-flex justify-content-start'>
                                        <div className='avis_via_restaurant'>
                                            <p>{item.avis[0]?.reponse}</p>
                                        </div>
                                    </div>
                                    : <div className='d-flex justify-content-start'>
                                        <div className='avis_via_restaurant'>
                                            <p>Pas de reponse ...</p>
                                        </div>
                                    </div>}

                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-2'>
                            <div className='photo'>
                                <span>Photo resto:</span>
                                <div>
                                    {item.avis[0]?.photoRestos.length !== 0 ?
                                        <Slider {...settings}>
                                            {item.avis[0]?.photoRestos.map((el, i) => {
                                                return (
                                                    <div className='photoResto' key={i}>
                                                        <img src={BASE_URL + el.photoUrl} alt='logo restaurant' />
                                                    </div>
                                                )
                                            })}

                                        </Slider>
                                        : <p>Pas de photo</p>}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )
        } else {
            return (
                <div className='card'>
                    <div className='row'>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-2'>
                            <div className='image_card'>
                                <img
                                    src={
                                        restaurant.photos.length === 0
                                            ? noImage
                                            : BASE_URL + restaurant.photos[0]?.urlPhoto
                                    }
                                    alt="logo restaurant"
                                />
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-2'>
                            <div className="apropos_restaurant">
                                <span>{restaurant.typeCuisines[0].libelle}</span>
                                <h3>{restaurant.nomRestaurant}</h3>
                                <span>{restaurant.adresse} </span>
                                <div className="date_personne">
                                    <span className='date'>Réservation du {formatDate(item.datePrise)}</span><br />
                                    <span className='personne'>Pour {item.nombrePersonne} pérsonnes</span>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                            <div className='apropos_avis'>
                                <Link to={`/depotAvisRestaurant/${restaurant.nomRestaurant}/${restaurant.adresse}/${restaurant.id}/${formatDateLink(item.datePrise)}/${formatTime(item.heurePrise)}/${item.nombrePersonne}/${item.id}/${client.id}`} className='btn btn_deposer_avis'>Déposer son avis</Link>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }


    }


    const handlePage = (event, value) => {
        setPage(value);
        AfficheAvisClient(value);
    }


    const handleDrop = () => {
        setOpenDropDown(!openDropDown);
    }

    const handleCroissonResa = () => {
        const sorted = [...totalResa].sort((a, b) => a.id > b.id ? 1 : -1);
        setData(sorted);
    }

    const handleDeCroissonResa = () => {
        const sorted = [...totalResa].sort((a, b) => a.id < b.id ? 1 : -1);
        setData(sorted);
    }

    const handleCroissonNote = () => {
        const sorted = [...totalResa].sort((a, b) => parseFloat(a.notes[0]?.note) > parseFloat(b.notes[0]?.note) ? 1 : -1);
        setData(sorted);
    }

    const handleDeCroissonNote = () => {
        const sorted = [...totalResa].sort((a, b) => parseFloat(a.notes[0]?.note) < parseFloat(b.notes[0]?.note) ? 1 : -1);
        setData(sorted);
    }

    const handleReset = () => {
        AfficheAvisClient();
    }



    return (
        <div>
            <Helmet>
                <title>Avis déposés ou à déposer</title>
                <meta name='description' content='Avis déposés ou à déposer' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='avis_client'>
                <div className='container'>
                    <div className='bloc_avis'>
                        <div className='titre'>
                            <h1><i className='fa fa-sticky-note'></i>Mes avis</h1>
                        </div>
                        <div className='sous_titre'>
                            <div>
                                <h2>Votre avis est important ! Pensez à noter le restaurant, sa prestation et y laisser
                                    un commentaire.</h2>
                                <span>Nombre de réservations : {totalResa.length} sur {totalAvis !== "" ? totalAvis : 0} avis déposés</span>
                            </div>
                            {totalResa !== "" ? <button className='btn btn_trier' onClick={handleDrop}>Trier par :</button> : ""}
                        </div>
                        <div className='col-xs-12 col-12 col-sm-12'>
                            <div className='d-flex justify-content-end'>
                                <div className={openDropDown === true ? "body-filter show" : "body-filter"}>
                                    <div className="filter-content">
                                        <div className="filter_titre">
                                            <li className='filter_resa'>Réservation</li>
                                            <li className='filter_note'>Note</li>
                                        </div>
                                        <div className="filter-value">
                                            <div className="body-valueResa">
                                                <span onClick={handleCroissonResa}>Croissant</span>
                                                <span className='ms-3' onClick={handleDeCroissonResa}>Décroissant</span>
                                            </div>
                                            <div className="body-valueNote">
                                                <span onClick={handleCroissonNote}>Croissant</span>
                                                <span className='ms-3' onClick={handleDeCroissonNote}>Décroissant</span>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="footer-value">
                                        <div className="action">
                                            <button className="btn btn_reinitialiser btn-sm" onClick={handleReset}>
                                                Reinitialiser
                                            </button>
                                            <button className="btn btn_fermerFilter btn-sm" onClick={() => setOpenDropDown(false)}>
                                                Fermer
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='list_restaurant' onClick={() => setOpenDropDown(false)}>


                            {loadData === true ?
                                <div className="d-flex justify-content-center">
                                    <Spinner
                                        animation="border"
                                        className="load"
                                        variant="info"
                                        size="md"
                                    />
                                </div>
                                :
                                data.map((item, index) => {
                                    return viewAvis(item, index);
                                })
                            }
                            {showPaginate && <div className='d-flex justify-content-center mt-4'>
                                <Pagination
                                    shape="rounded"
                                    count={Math.ceil(totalPage)}
                                    onChange={handlePage}
                                />
                            </div>
                            }

                        </div>
                        <p className="version">Version 1</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Avis